import englishMessages from 'ra-language-english'
import commonLang from '../lang/common-lang.json'
import deepMerge from 'deepmerge'

const commonLangLabels = {
  ...commonLang,
  ...englishMessages,
}

// with this function we merge the common labels with the local labels provided by each one of the specific labels for each country
export const overrideCommon = (localMessages: object) =>
  deepMerge(commonLangLabels, localMessages)
